import { FC, useEffect, useState } from "react";
import Link from "next/link";
import _ from "lodash";

import ComputerIcon from "@mui/icons-material/Computer";
import { Box } from "@mui/material";
import Carousel from "components/carousel/Carousel";
import CategorySectionCreator from "components/CategorySectionCreator";
import { BuildGalleryListItem } from "components/builds-gallery/components/BuildGalleryListItem";

import useWindowSize from "hooks/useWindowSize";

import { ProductsSkeleton } from "components/skeletons";
import { BuildsGalleryItem } from "modules/builds-gallery/types";
import { useBuildsGallery } from "hooks/use-builds-gallery";

type Props = {
  buildsItems?: BuildsGalleryItem[];
  buildsGalleryLoading?: boolean;
  productName?: string;
};

const BuildsGalleryCarousel: FC<Props> = ({
  buildsItems,
  buildsGalleryLoading,
  productName,
}) => {
  const { getBuildsGalleryProductName } = useBuildsGallery();

  const [visibleSlides, setVisibleSlides] = useState(4);
  const width = useWindowSize();

  useEffect(() => {
    if (width < 500) setVisibleSlides(2);
    else if (width < 650) setVisibleSlides(2);
    else if (width < 950) setVisibleSlides(3);
    else setVisibleSlides(4);
  }, [width]);

  return (
    <CategorySectionCreator
      sx={{ marginTop: 3, marginX: -2 }}
      icon={<ComputerIcon color="secondary" fontSize="small" />}
      title="Recommended PC builds that include this product."
      titleFontSize="medium"
      seeMoreLink="/builds-gallery"
      onClick={() => getBuildsGalleryProductName(productName)}
    >
      {buildsItems?.length > 0 ? (
        <Carousel
          showArrow
          spacing={"-0.5rem"}
          infinite={false}
          showArrowOnHover
          totalSlides={buildsItems.length === 1 ? 2 : buildsItems.length || 1}
          visibleSlides={visibleSlides}
        >
          {buildsItems.map((buildsItem, index) => (
            <Box key={index} sx={{ p: 1 }}>
              <Link
                passHref
                href={{
                  pathname: `/builds-gallery/details/${buildsItem.uuid}`,
                }}
                key={`${buildsItem.uuid}`}
              >
                <BuildGalleryListItem
                  data={buildsItem}
                  key={buildsItem.uuid}
                  onClick={undefined}
                />
              </Link>
            </Box>
          ))}
          {buildsGalleryLoading
            ? _.map([1, 2, 3, 4, 5, 6], (item, ind) => (
                <Box sx={{ marginX: 1 }}>
                  <ProductsSkeleton />
                </Box>
              ))
            : null}
        </Carousel>
      ) : null}
    </CategorySectionCreator>
  );
};

export default BuildsGalleryCarousel;
